// extracted by mini-css-extract-plugin
export default {"Fretboard":"Fretboard_Fretboard__LMWMp","quesIcon":"Fretboard_quesIcon__7K3cA"};